module.exports = __webpack_public_path__ + "img/0Q3B7249_Wood_MockedUp.ec80110d.jpg";